class TabChange {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const triggers = document.querySelectorAll(".s-profile__right-trigger");
    // const tabs = document.querySelectorAll(".s-profile__right-tab");
  
    // triggers.forEach(trigger => {
    //   trigger.addEventListener("click", () => {
    //     const triggerNum = trigger.getAttribute("data-num");

    //     triggers.forEach(el => el.classList.remove("is-active"));
    //     trigger.classList.add("is-active");
          
    //     tabs.forEach(tab => tab.classList.remove("is-active"));
    //     tabs.forEach(tab => {
    //       const tabNum = tab.getAttribute("data-tab");
    //       if (triggerNum === tabNum) {
    //         tab.classList.add("is-active");
    //       }
    //     });
    //   });
    // });

    $('.s-profile__right-trigger').click(function() {
      $(this).addClass('is-active');
      $(this).siblings().removeClass('is-active');

      $('.s-profile__right-tab').css({'display': 'none'});
      $('.s-profile__picture').css({'display': 'none'});
      $('.s-profile__right-tab').eq($(this).index()).fadeIn();
      $('.s-profile__picture').eq($(this).index()).fadeIn(1);
    })

  }
}
